import { defineMessages } from 'react-intl';

export default defineMessages({
    quote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Homeowners Insurance Quote',
        defaultMessage: 'Quote',
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Location',
        defaultMessage: 'Location',
    },
    close: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.close',
        defaultMessage: 'Close',
    },
    cancel: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.cancel',
        defaultMessage: 'Cancel',
    }
});
